import api from './content/_generated.js'
import fm from 'front-matter';

function isPackage(fullyQualifiedName) {
    for (var i = api.files.length - 1; i >= 0; i--) {
        var file = api.files[i];
        if (file.package === fullyQualifiedName) {
            return true;
        }
    }
    return false;
}

function findDefinition(keyPath, fullyQualifiedName) {
    var firstKey = keyPath;
    if (keyPath === "services.methods") {
        firstKey = "services";
    }

    for (var i = api.files.length - 1; i >= 0; i--) {
        var file = api.files[i];
        for (var j = file[firstKey].length - 1; j >= 0; j--) {
            var candidateDefinition = file[firstKey][j];
            if (keyPath === "services.methods") {
                for (var k = candidateDefinition.methods.length - 1; k >= 0; k--) {
                    var candidateMethod = candidateDefinition.methods[k];
                    if (candidateDefinition.fullName + "." + candidateMethod.name === fullyQualifiedName) {
                        return candidateMethod;
                    }
                }
            } else {
                if (candidateDefinition.fullName === fullyQualifiedName) {
                    return candidateDefinition;
                }
            }
        }
    }
    return undefined;
}

function findScalarValueType(fullyQualifiedName) {
    for (var i = api.scalarValueTypes.length - 1; i >= 0; i--) {
        var candidateScalarValueType = api.scalarValueTypes[i];
        if (candidateScalarValueType.protoType === fullyQualifiedName) {
            return candidateScalarValueType;
        }
    }
    return undefined;
}

class Store {

    packageNames() {
        return [
            "happyco.type.v1",
            "happyco.manage.folder.v1",
            "happyco.manage.asset.v1",
            "happyco.manage.account.v1",
            "happyco.manage.account_provisioning.v1",
            "happyco.inspect.type.v1",
            "happyco.inspect.inspection.v1",
            "happyco.inspect.template.v1",
            "happyco.inspect.report.v1"
        ];
    }

    breadcrumbItem(fullyQualifiedName) {
        if (isPackage(fullyQualifiedName)) {
            return {
                name: fullyQualifiedName,
                fullName: fullyQualifiedName
            }
        }

        let scalarValueType = findScalarValueType(fullyQualifiedName);
        if (scalarValueType) {
            return {
                name: fullyQualifiedName,
                fullName: fullyQualifiedName
            }
        }

        let service = findDefinition("services", fullyQualifiedName);
        if (service) {
            return {
                name: service.name,
                fullName: fullyQualifiedName,
                parentFullName: fullyQualifiedName.substring(0, fullyQualifiedName.length - service.name.length - 1)
            };
        }

        let method = findDefinition("services.methods", fullyQualifiedName);
        if (method) {
            let parentFullName = fullyQualifiedName.substring(0, fullyQualifiedName.length - method.name.length - 1);
            return {
                name: method.name,
                fullName: fullyQualifiedName,
                parentFullName: parentFullName,
                link: parentFullName + "#" + method.name
            };
        }

        let message = findDefinition("messages", fullyQualifiedName);
        if (message) {
            return {
                name: message.name,
                fullName: fullyQualifiedName,
                parentFullName: fullyQualifiedName.substring(0, fullyQualifiedName.length - message.name.length - 1)
            }
        }

        let enumType = findDefinition("enums", fullyQualifiedName);
        if (enumType) {
            return {
                name: enumType.name,
                fullName: fullyQualifiedName,
                parentFullName: fullyQualifiedName.substring(0, fullyQualifiedName.length - enumType.name.length - 1)
            }
        }

        return undefined;
    }

    path(fullyQualifiedName) {
        var item = this.breadcrumbItem(fullyQualifiedName);
        if (item.parentFullName) {
            return this.path(item.parentFullName) + "/" + item.name;
        } else {
            return item.name;
        }
    }

    loadFile(fullyQualifiedName, name) {
        var contents = "";
        try {
            contents = require(`!raw-loader!./content/${this.path(fullyQualifiedName)}/${name}`);
        } catch (error) {
            // file doesn't exist likely
        }
        return contents;
    }

    descriptor(fullyQualifiedName) {
        const overlay = fm(this.loadFile(fullyQualifiedName, "overview.md"));
        if (isPackage(fullyQualifiedName)) {
            var files = api.files.filter((file) => { return file.package === fullyQualifiedName; });
            if (overlay.attributes && overlay.attributes.messages) {
                for (let i = files.length - 1; i >= 0; i--) {
                    let file = files[i];
                    for (var j = file.messages.length - 1; j >= 0; j--) {
                        let messageName = file.messages[j].name;
                        let messageOverlay = (overlay.attributes.messages || {})[messageName];
                        if (messageOverlay) {
                            file.messages[j].hidden = messageOverlay.hidden || false;
                        }
                    }
                }
            }
            return {
                kind: "package",
                fullName: fullyQualifiedName,
                package: {
                    fullName: fullyQualifiedName,
                    summary: overlay.attributes.summary,
                    overview: overlay.body,
                    files: files,
                    index: JSON.parse(this.loadFile(fullyQualifiedName, "index.json"))
                }
            }
        }

        let scalarValueType = findScalarValueType(fullyQualifiedName);
        if (scalarValueType) {
            let scalarValueTypeOverlay = overlay[fullyQualifiedName];
            if (scalarValueTypeOverlay) {
                scalarValueType.summary = scalarValueTypeOverlay.summary || "";
            }
            return {
                kind: "scalarValueType",
                fullName: fullyQualifiedName,
                scalarValueType: scalarValueType
            }
        }

        let service = findDefinition("services", fullyQualifiedName);
        if (service) {
            if (overlay) {
                if (overlay.attributes && overlay.attributes.summary) {
                    service.summary = overlay.attributes.summary;
                }
            }
            return {
                kind: "service",
                fullName: fullyQualifiedName,
                service: service
            };
        }

        let message = findDefinition("messages", fullyQualifiedName);
        if (message) {
            if (overlay) {
                if (overlay.attributes && overlay.attributes.summary) {
                    message.summary = overlay.attributes.summary;
                }
                message.overview = overlay.body;
                if (overlay.attributes && overlay.attributes.fields) {
                    for (let i = message.fields.length - 1; i >= 0; i--) {
                        let fieldName = message.fields[i].name;
                        let fieldOverlay = (overlay.attributes.fields || {})[fieldName];
                        if (fieldOverlay) {
                            message.fields[i].description = fieldOverlay.summary || message.fields[i].description;
                            message.fields[i].hidden = fieldOverlay.hidden || false;
                        }
                    }
                }
            }
            const example = this.loadFile(fullyQualifiedName, "example.js");
            if (example) {
                message.exampleCode = { javaScript: example };
            }
            return {
                kind: "message",
                fullName: fullyQualifiedName,
                message: message
            }
        }

        let enumType = findDefinition("enums", fullyQualifiedName);
        if (enumType) {
            if (overlay) {
                if (overlay.attributes && overlay.attributes.summary) {
                    enumType.summary = overlay.attributes.summary;
                }
                enumType.overview = overlay.body;
            }
            return {
                kind: "enum",
                fullName: fullyQualifiedName,
                enum: enumType
            }
        }

        return undefined;
    }

}

export default Store;



// WEBPACK FOOTER //
// ./src/reference/Store.js